export const ADMIN_TEXTS = {
  common: {
    loading: "Loading...",
    cancel: "Cancel",
    save: "Save",
    create: "Create",
    edit: "Edit",
    delete: "Delete",
    view: "View",
    back: "Back",
    active: "Active",
    inactive: "Inactive",
    order: "Order",
    title: "Title",
    description: "Description",
    image: "Image",
    media: "Media",
    mobileMedia: "Mobile Media",
    upload: "Upload",
    change: "Change",
    remove: "Remove",
    noData: "No data found",
    confirm: "Confirm",
    yes: "Yes",
    no: "No",
    error: "Error",
    success: "Success",
    info: "Info",
    warning: "Warning",
    created: "Created",
    update: "Update",
    selectItems: "Select Items",
  },

  products: {
    management: "Gallery - Items",
    create: "Create Item",
    edit: "Edit Item",
    details: "Item Details",

    productTitle: "Item Title",
    productTitleAsterisk: "Item Title*",
    productDescription: "Item Description",
    buttonLink: "Button Link",
    buttonLinkAsterisk: "Button Link*",
    productImage: "Product Image",
    productImageRequired: "Product image is required",
    buttonLinkRequired: "Button link is required",
    price: "Price",

    enterTitle: "Enter product title",
    enterDescription: "Enter product description",
    enterButtonLink: "https://example.com",
    uploadImage: "Upload a product image",
    chooseImage: "Choose Image",
    changeImage: "Change Image",

    noProducts: "No products found",
    noProductsMessage: "Create your first product to get started",
    createFirstProduct: "Create Product",
    createProduct: "Create Product",
    updateProduct: "Update Product",
    deleteProduct: "Delete Product",
    deleteConfirm: "Are you sure you want to delete",
    deleteConfirmMessage: "This action cannot be undone.",
    reorderingProducts: "Reordering products...",
    homeSlider: "Home Slider",

    titleRequired: "Title is required",
    titleMinLength: "Title must be at least 3 characters",
    titleMaxLength: "Title must be less than 100 characters",
    descriptionRequired: "Description is required",
    descriptionMinLength: "Description must be at least 10 characters",
    descriptionMaxLength: "Description must be less than 2000 characters",
    buttonLinkInvalid: "Must be a valid URL",
    priceAsterisk: "Price *",
    enterPrice: "Enter price",
    priceMustBeNumber: "Price must be a number",
    priceRequired: "Price is required",
    priceMinValue: "Price must be 0 or greater",

    categoryLabel: "Category",
    subcategoryLabel: "Subcategory",
    categoryNone: "None",

    file: "File",
    size: "Size",
    type: "Type",
    created: "Created",
    updated: "Updated",

    information: "Information",
    productNotFound: "Product not found",
    backToProducts: "Back to Products",
  },

  home: {
    metaDetailsTitle: "Home - Meta Details",
  },

  heroSection: {
    pageTitle: "Home - Hero Section",
  },

  menuSlider: {
    pageTitle: "Home - Menu Slider",
    addToSlider: "Add To Slider",
    inMenuSlider: "In Menu Slider",
    notInMenuSlider: "Not in Menu Slider",
    noItems: "No items in the slider yet",
    noItemsHint: 'Click "Add To Slider" to select products.',
    reordering: "Reordering...",
    productImageAlt: "Product",
  },

  pickupDelivery: {
    pageTitle: "Home - Pickup & Delivery",
    pickupImage: "Pickup Image",
    deliveryImage: "Delivery Image",
    mediaRequired: "Media is required. Please upload an image or video.",
    pickupLinkLabel: "Pickup Link",
    deliveryLinkLabel: "Delivery Link",
    linkHelperText: "e.g. https://example.com/order",
  },

  heroSections: {
    management: "Hero Sections Management",
    create: "Create Hero Section",
    edit: "Edit Hero Section",
    details: "Hero Section Details",

    heroTitle: "Title",
    heroDescription: "Description",
    buttonName: "Button Name",
    buttonLink: "Button Link",
    mediaUpload: "Media Upload",
    mobileMediaUpload: "Mobile Media Upload",

    enterHeroTitle: "Enter hero section title",
    enterHeroDescription: "Enter hero section description",
    enterButtonName: "Enter button text",
    enterHeroButtonLink: "https://example.com",
    uploadMedia: "Upload Media",
    changeMedia: "Change Media",

    noHeroSections: "No hero sections found",
    noHeroSectionsMessage: "Create your first hero section to get started",
    createFirstHeroSection: "Create Hero Section",
    createHeroSection: "Create Hero Section",
    updateHeroSection: "Update Hero Section",
    deleteHeroSection: "Delete Hero Section",
    deleteConfirm: "Are you sure you want to delete",
    deleteConfirmMessage: "This action cannot be undone.",
    reorderingHeroSections: "Reordering hero sections...",

    titleMaxLength: "Title must be less than 255 characters",
    descriptionMaxLength: "Description must be less than 1000 characters",
    buttonNameMaxLength: "Button name must be less than 100 characters",
    buttonLinkInvalid: "Please enter a valid URL",

    currentMedia: "Current Media",
    supportedFormats:
      "Supported formats: Images (JPG, PNG, GIF, WebP) and Videos (MP4, WebM)",
    removeMedia: "Remove Media",
    mediaRequired: "Media is required. Please upload an image or video.",
    mobileMediaRequired:
      "Mobile media is required. Please upload a mobile image or video.",

    heroSectionNotFound: "Hero section not found",
    backToHeroSections: "Back to Hero Sections",
  },

  homepageImages: {
    management: "Homepage Images Management",
    create: "Upload Homepage Image",
    edit: "Edit Homepage Image",
    details: "Homepage Image Details",

    imageUpload: "Image Upload",
    uploadImage: "Upload Image",
    changeImage: "Change Image",

    noHomepageImages: "No homepage images found",
    noHomepageImagesMessage: "Upload your first image to get started",
    uploadFirstImage: "Upload Image",
    updateImage: "Update Image",
    deleteImage: "Delete Image",
    deleteConfirm: "Are you sure you want to delete",
    deleteConfirmMessage: "This action cannot be undone.",
    reorderingImages: "Reordering images...",

    imageRequired: "Image is required",
    imageType: "Please upload an image file",
    imageSize: "Image size must be less than 10MB",

    currentImage: "Current Image",
    supportedFormats:
      "Supported formats: Images (JPG, PNG, GIF, WebP) and Videos (MP4, WebM)",
    removeImage: "Remove Image",

    homepageImageNotFound: "Homepage image not found",
    backToHomepageImages: "Back to Homepage Images",
    noImage: "No image available",
  },

  homeBanner: {
    management: "Home Banner Management",
    edit: "Edit Home Banner",
    details: "Home Banner Details",

    title: "Title",
    titleAsterisk: "Title*",
    description: "Description",
    descriptionAsterisk: "Description*",
    buttonName: "Button Name",
    buttonNameAsterisk: "Button Name*",
    buttonLink: "Button Link",
    buttonLinkAsterisk: "Button Link*",
    image: "Image",
    imageAsterisk: "Image*",

    enterTitle: "Enter banner title",
    enterDescription: "Enter banner description",
    enterButtonName: "Enter button text",
    enterButtonLink: "https://example.com",
    uploadImage: "Upload Image",
    changeImage: "Change Image",

    noHomeBanner: "No home banner found",
    noHomeBannerMessage: "Home banner will be created automatically",
    updateHomeBanner: "Update Home Banner",
    homeBannerUpdated: "Home banner updated successfully",

    titleRequired: "Title is required",
    titleMaxLength: "Title must be less than 255 characters",
    descriptionRequired: "Description is required",
    descriptionMaxLength: "Description must be less than 1000 characters",
    buttonNameRequired: "Button name is required",
    buttonNameMaxLength: "Button name must be less than 100 characters",
    buttonLinkRequired: "Button link is required",
    buttonLinkInvalid: "Please enter a valid URL",

    currentImage: "Current Image",
    supportedFormats:
      "Supported formats: Images (JPG, PNG, GIF, WebP) and Videos (MP4, WebM)",
    removeImage: "Remove Image",
    imageSize: "Image size must be less than 10MB",

    homeBannerNotFound: "Home banner not found",
    backToHomeBanner: "Back to Home Banner",
  },

  contacts: {
    management: "Contact Us Management",
    create: "Create Contact",
    edit: "Edit Contact",
    details: "Contact Details",
    contactDetails: "Contact Details",

    title: "Title",
    titleAsterisk: "Title*",
    description: "Description",
    descriptionAsterisk: "Description*",
    contact: "Contact",
    contactAsterisk: "Contact*",
    type: "Type",
    icon: "Icon",

    enterTitle: "Enter contact title",
    enterDescription: "Enter contact description",
    enterContact: "Enter contact information",
    uploadIcon: "Upload Icon",
    changeIcon: "Change Icon",
    removeIcon: "Remove Icon",
    currentIcon: "Current Icon",
    iconUpload: "Icon Upload",

    noContacts: "No contacts found",
    noContactsMessage: "Create your first contact to get started",
    createFirstContact: "Create First Contact",
    createContact: "Create Contact",
    noData: "No data available",
    noIcon: "No icon uploaded",

    titleRequired: "Title is required",
    titleMaxLength: "Title must be less than 255 characters",
    descriptionRequired: "Description is required",
    descriptionMaxLength: "Description must be less than 1000 characters",
    contactRequired: "Contact information is required",
    contactMaxLength: "Contact information must be less than 255 characters",
    emailInvalid: "Please enter a valid email address",
    phoneInvalid: "Please enter a valid phone number",
    typeRequired: "Type is required",
    typeInvalid: "Type must be either email or phone",
    iconRequired: "Icon is required. Please upload an icon.",

    deleteContact: "Delete Contact",
    deleteConfirm: "Are you sure you want to delete",
    deleteConfirmMessage: "This action cannot be undone.",
    contactNotFound: "Contact not found",

    supportedFormats:
      "Supported formats: Images (JPG, PNG, GIF, WebP) and Videos (MP4, WebM)",
  },

  faqs: {
    management: "FAQ Management",
    create: "Create FAQ",
    edit: "Edit FAQ",
    details: "FAQ Details",
    faqDetails: "FAQ Details",

    question: "Question",
    questionAsterisk: "Question*",
    answer: "Answer",
    status: "Status",
    statusControl: "Status Control",

    enterQuestion: "Enter FAQ question",
    enterAnswer: "Enter FAQ answer",
    noData: "No data available",

    noFaqs: "No FAQs found",
    noFaqsMessage: "Create your first FAQ to get started",
    createFirstFaq: "Create First FAQ",
    createFaq: "Create FAQ",
    faqNotFound: "FAQ not found",

    questionRequired: "Question is required",
    questionMaxLength: "Question must be less than 500 characters",
    answerRequired: "Answer is required",
    answerMinLength: "Answer must be at least 10 characters",
    answerMaxLength: "Answer must be less than 2000 characters",
    statusRequired: "Status is required",
    statusInvalid: "Status must be either active or inactive",

    deleteFaq: "Delete FAQ",
    deleteConfirm: "Are you sure you want to delete",
    deleteConfirmMessage: "This action cannot be undone.",

    faqInfo: "FAQ Information",
    faqInfoMessage: "Create helpful FAQs for your users",
    questionLength: "Question Length",
    questionLengthMessage:
      "Keep questions concise and clear (max 500 characters)",
    answerLength: "Answer Length",
    answerLengthMessage:
      "Provide detailed and helpful answers (max 2000 characters)",
    statusInfo: "Status Information",
    statusInfoMessage:
      "Active FAQs are visible to users, inactive ones are hidden",

    activeMessage: "This FAQ is visible to users",
    inactiveMessage: "This FAQ is hidden from users",
    statusToggleInfo: "Toggle the switch to change FAQ visibility status",
  },

  about: {
    aboutContent: "About Us - Content",
    metaDetailsTitle: "About Us - Meta Details",
    title: "Title",
    titleAsterisk: "Title*",
    description: "Description",
    descriptionAsterisk: "Description*",
    media1: "Media 1",
    media1Asterisk: "Media 1*",
    media2: "Media 2",
    media2Asterisk: "Media 2*",

    enterTitle: "Enter about title",
    enterDescription: "Enter about description",
    uploadMedia: "Upload Media",
    changeMedia: "Change Media",
    removeMedia: "Remove Media",
    mediaRequired: "Media is required. Please upload an image or video.",

    titleRequired: "Title is required",
    titleMaxLength: "Title must be at most 255 characters",
    descriptionRequired: "Description is required",
    descriptionMinLength: "Description must be at least 10 characters",
    descriptionMaxLength: "Description must be at most 2000 characters",

    noData: "No data available",
    noMedia: "No media uploaded",
  },

  aboutStats: {
    aboutStats: "About Stats",
    createStat: "Create Stat",
    editStat: "Edit Stat",
    statDetails: "Stat Details",
    name: "Name",
    nameAsterisk: "Name*",
    value: "Value",
    valueAsterisk: "Value*",

    enterName: "Enter stat name",
    enterValue: "Enter stat value",

    nameRequired: "Name is required",
    nameMaxLength: "Name must be at most 255 characters",
    valueRequired: "Value is required",
    valueMaxLength: "Value must be at most 7 characters",

    noStats: "No stats found",
    noStatsDescription: "Create your first stat to get started",
    createFirstStat: "Create First Stat",
    statNotFound: "Stat not found",
    confirmDelete: "Are you sure you want to delete this stat?",
    deleteStat: "Delete Stat",
    deleteConfirmMessage: "This action cannot be undone.",
  },

  aboutStatsSection: {
    aboutStatsSection: "About Stats Section",
    title: "Title",
    titleAsterisk: "Title*",
    description: "Description",
    descriptionAsterisk: "Description*",

    enterTitle: "Enter section title",
    enterDescription: "Enter section description",

    titleRequired: "Title is required",
    titleMaxLength: "Title must be at most 255 characters",
    descriptionRequired: "Description is required",
    descriptionMinLength: "Description must be at least 10 characters",
    descriptionMaxLength: "Description must be at most 2000 characters",

    noData: "No data available",
  },

  aboutImages: {
    aboutImages: "About Images",
    addImage: "Add Image",
    editImage: "Edit Image",
    imageDetails: "Image Details",
    imageUpload: "Image Upload",
    selectImage: "Select Image",
    removeImage: "Remove Image",
    image: "Image",
    imageInfo: "Image Information",
    order: "Order",
    createdAt: "Created At",
    updatedAt: "Updated At",
    actions: "Actions",

    noImages: "No images found",
    noImagesDescription: "Add your first image to get started",
    addFirstImage: "Add First Image",
    imageNotFound: "Image not found",

    imageRequired: "Image is required",
    imageType: "Only image files are allowed (JPEG, PNG, GIF, WebP)",
    imageSize: "Image size must be less than 10MB",

    confirmDelete: "Are you sure you want to delete this image?",
    deleteImage: "Delete Image",

    createSuccess: "Image created successfully",
    updateSuccess: "Image updated successfully",
    error: "An error occurred",
  },

  actions: {
    saving: "Saving...",
    updating: "Updating...",
    creating: "Creating...",
    deleting: "Deleting...",
    loading: "Loading...",
  },

  status: {
    active: "Active",
    inactive: "Inactive",
    published: "Published",
    draft: "Draft",
  },

  fileUpload: {
    dragAndDrop: "Drag and drop files here",
    or: "or",
    browseFiles: "Browse files",
    fileSizeLimit: "File size limit: 10MB",
    supportedFormats: "Supported formats",
    maxFiles: "Maximum files allowed",
  },

  navigation: {
    home: "Home",
    products: "Products",
    heroSections: "Hero Sections",
    homepageImages: "Homepage Images",
    homeBanner: "Home Banner",
    payments: "Payments",
  },

  tooltips: {
    dragToReorder: "Drag to reorder",
    clickToView: "Click to view",
    clickToEdit: "Click to edit",
    clickToDelete: "Click to delete",
    toggleActive: "Toggle active status",
  },

  menuCategories: {
    pageTitle: "Menu - Categories",
    addCategory: "Add Category",
    createCategory: "Create Category",
    updateCategory: "Update",
    editCategory: "Edit Category",
    noCategories: "No categories found",
    noCategoriesMessage: "Create your first category to get started",
    reordering: "Reordering categories...",
    untitledCategory: "Untitled Category",
    deleteCategory: "Delete Category",
    deleteConfirm: "Are you sure you want to delete",
    deleteConfirmMessage: "This action cannot be undone.",
    imageLabel: "Image *",
    uploadImage: "Upload a category image",
    imageRequired: "Image is required",
    nameLabel: "Name *",
    enterName: "Enter category name",
    nameRequired: "Name is required",
    nameMinLength: "Name must be at least 2 characters",
    nameMaxLength: "Name must be less than 100 characters",
    itemsModalTitle: "Select Category Items",
    manageItems: "Manage Items",
  },

  menuSubcategories: {
    sectionTitle: "Subcategories",
    addSubcategory: "Add Subcategory",
    editSubcategory: "Edit Subcategory",
    createSubcategory: "Create Subcategory",
    updateSubcategory: "Update Subcategory",
    deleteSubcategory: "Delete Subcategory",
    deleteConfirm: "Are you sure you want to delete",
    deleteConfirmMessage: "This action cannot be undone.",
    noSubcategories: "No subcategories yet",
    nameLabel: "Name *",
    enterName: "Enter subcategory name",
    nameRequired: "Name is required",
    categoryLabel: "Category",
    selectCategory: "Select a category",
    reordering: "Reordering...",
    manageItems: "Manage Items",
    itemsModalTitle: "Select Subcategory Items",
    noItems: "No items assigned",
  },

  contactUs: {
    contactsPageTitle: "Contact Us - Contacts",
    locationsPageTitle: "Contact Us - Locations",
    socialMediaPageTitle: "Contact Us - Social Media",
    metaDetailsPageTitle: "Contact Us - Meta Details",

    receiverEmailLabel: "Receiver Email",
    emailInvalid: "Please enter a valid email",
    emailRequired: "Email is required",
    phoneNumberLabel: "Phone Number",
    phoneNumberRequired: "Phone number is required",
    workingHoursTitle: "Working Hours",
    fromLabel: "From",
    toLabel: "To",
    opensLabel: "Opens",
    closesLabel: "Closes",
    hoursPreviewLabel: "Preview:",

    addressLabel: "Address",
    addressRequired: "Address is required",
    mapSourceLabel: "Map Source",
    mapSourceRequired: "Map source is required",
    mapSourceHelperText:
      "Paste an <iframe> embed code, a Google Maps URL, or a plain address",
    previewMapBtn: "Preview Map",
    mapPreviewLabel: "Map Preview",
    mapPreviewEmpty: "Paste a map source and click Preview Map",

    addBtn: "Add",
    addDialogTitle: "Add Social Media",
    nameLabel: "Name",
    urlLabel: "URL",
    iconImageLabel: "Icon Image",
    nameRequired: "Name is required",
    iconRequired: "Icon image is required",
    urlRequired: "URL is required",
    urlInvalid: "Please enter a valid URL starting with http:// or https://",
    noLinks: "No social media links yet",
    noLinksHint: 'Click "Add" to create your first entry',
    nameHelperText: "e.g. Facebook, Instagram",
    urlHelperText: "e.g. https://facebook.com/yourpage",
    uploadIconHint: "Click to upload icon",
    changeIconTooltip: "Click to change icon",

    settingsNotCreatedYet:
      "Contact settings haven't been created yet. Please save the Contacts tab first.",

    genericError: "Something went wrong",
    saving: "Saving...",
    save: "Save",
    cancel: "Cancel",
  },

  getOurApp: {
    title: "Get Our App",
    titleAsterisk: "Title*",
    edit: "Edit",
    notFound: "Get Our App content not found",
    image: "Image",
    imageAsterisk: "Image*",
    descriptionAsterisk: "Description*",

    titleRequired: "Title is required",
    titleMaxLength: "Title must be less than 255 characters",
    descriptionRequired: "Description is required",
    descriptionMinLength: "Description must be at least 10 characters",
    descriptionMaxLength: "Description must be less than 2000 characters",
    appStoreLinkRequired: "App Store link is required",
    appStoreLinkInvalid: "Please enter a valid App Store URL",
    appStoreLinkMaxLength: "App Store link must be less than 500 characters",
    playMarketLinkRequired: "Play Market link is required",
    playMarketLinkInvalid: "Please enter a valid Play Market URL",
    playMarketLinkMaxLength:
      "Play Market link must be less than 500 characters",

    enterTitle: "Enter app title",
    enterDescription: "Enter app description",
    selectImage: "Select Image",
    removeImage: "Remove Image",
    noImage: "No image uploaded",

    updateSuccess: "Get Our App updated successfully",
    updateError: "Failed to update Get Our App",

    appStoreLink: "App Store Link",
    appStoreLinkAsterisk: "App Store Link*",
    playMarketLink: "Play Market Link",
    playMarketLinkAsterisk: "Play Market Link*",
  },

  privacyPolicy: {
    contentPageTitle: "Privacy Policy - Content",
    metaDetailsPageTitle: "Privacy Policy - Meta Details",
    contentLabel: "Content *",
    contentPlaceholder: "Enter privacy policy content...",
    contentRequired: "Content is required",
    contentMinLength: "Content must be at least 10 characters",
    genericError: "Something went wrong",
  },

  gallery: {
    productsTitle: "Gallery - Items",
    metaDetailsTitle: "Gallery - Meta Details",
    pageTitle: "Page Title *",
    metaTitle: "Meta Title *",
    metaDescription: "Meta Description *",
    metaKeywords: "Meta Keywords",
    ogTitle: "Open Graph Title",
    ogDescription: "Open Graph Description",
    ogImageLabel: "Open Graph Image",
    ogImageRecommendedSize: "Recommended size: 1200 × 630px",
    changeImage: "Change Image",
    uploadImage: "Upload Image",
    canonicalUrl: "Canonical URL",
    pageTitlePlaceholder: "Enter page title",
    metaTitlePlaceholder: "Enter meta title",
    metaKeywordsPlaceholder: "keyword1, keyword2, keyword3",
    metaDescriptionPlaceholder: "Enter meta description",
    ogTitlePlaceholder: "Enter Open Graph title",
    ogDescriptionPlaceholder: "Enter Open Graph description",
    canonicalUrlPlaceholder: "https://example.com/gallery",
    saving: "Saving...",
  },
};
